const logLevel = process.env.LOG_LEVEL || 'INFO';

const levels = {
	FATAL: 0,
	ERROR: 1,
	WARN: 2,
	INFO: 3,
	DEBUG: 4,
	TRACE: 5
};

const stderrLevels = new Set();
Object.keys(levels).forEach((level) => {
	if (levels[level] < levels.INFO) {
		stderrLevels.add(level);
	}
});

const colors = {
	FATAL: 'red bold',
	ERROR: 'red',
	WARN: 'yellow',
	INFO: 'green',
	DEBUG: 'cyan',
	TRACE: 'blue'
};

module.exports = { levels, logLevel, stderrLevels, colors };
